import { GET_USER, USERS_ERROR } from './types';
import URL from './url';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

// Upload archivos de inversions
export const uploadInvestment = formData => async dispatch => {
  try {
    const res = await URL.post(`/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
}

// Add user recibo de inversion
export const addInvestment = (formData, id, idInv) => async dispatch => {
  try {
    const res = await URL.patch(`/api/users/${id}/inversion/${idInv}`, formData, config);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
    return res.data;

  } catch (err) {
    console.error("Error", err);
    dispatch({
      type: USERS_ERROR,
      payload: err
    });
  }
}

// Procesamiento de pago en mercado pago
export const processPayment = async formData => {
  try {
    const response = await URL.post("/api/payments/mercadopago/create-preference", formData, config);
    return response.data;
  } catch (error) {
    console.error('Error al procesar el pago:', error);
    throw error;
  }
}

// Obtener información de pago de Mercado Pago
export const getPaymentInfo = async paymentId => {
  try {
    const response = await URL.get(`/api/payments/mercadopago/payment-info?payment_id=${paymentId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener información de pago:', error);
    throw error;
  }
};

/**************************ENVIOS DE EMAIL**********************************/
// Enviar email de aprobacion de inversion (2026)
export const sendEmailApproval = async formData => {
  try {
    const res = await URL.post(`/api/users/send/email/inversionistas`, formData, config);
    return res.data;
  } catch (err) {
    console.log(err, 'Error al enviar el email de aprobación de inversión');
  }
}

// Enviar email de aprobacion de inversion
export const sendEmailAdmin = () => async dispatch => {
  try {
    const res = await URL.post(`/api/users/send/email/administradores`, {}, config);
    return res.data;
  } catch (err) {
    console.log(err, 'Error al enviar el email de aprobación de inversión');
  }
}

// Función para consultar el estado de la captura
export const checkCaptureStatus = async captureId => {
  try {
    const response = await URL.get(`/check-capture/${captureId}`);
    const { status, status_details } = response.data;
    if (status === 'COMPLETED') {
      return 'success';
    } else if (status === 'PENDING') {
      console.log(`Pago pendiente, motivo: ${status_details?.reason}`);
      return 'pending';
    } else {
      setError(`Pago no completado. Motivo: ${status_details?.reason || 'Desconocido'}`);
      return 'error';
    }
  } catch (error) {
    console.error('Error al consultar captura:', error);
    return;
  }
};

